import { protectionStore } from '../../store/protectionStore';

export default function isAutoLabelEnabled(): boolean {
    const checkAutoLabelEnabledReducer = (acc, curValue) => {
        let doesChildrenHasAutoLabelOn = false;
        if (curValue.children && curValue.children.length > 0) {
            doesChildrenHasAutoLabelOn = curValue.children.reduce(
                checkAutoLabelEnabledReducer,
                false
            );
        }
        return acc || curValue.isAutoLabelingOn || doesChildrenHasAutoLabelOn;
    };
    const isAutoLabelEnabled = protectionStore.clpLabels.reduce(
        checkAutoLabelEnabledReducer,
        false /*initial value*/
    );
    return isAutoLabelEnabled;
}
